import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";

@Injectable()
export class VendorReviewCreateEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.vendorReview.create),
			switchMap((action) =>
				this.orderProposalService.reviewVendor(action.request).pipe(
					map(() =>
						OrderProposalActions.vendorReview.createSuccess({
							vendorId: action.vendorId
						})
					),
					catchError((error) => of(OrderProposalActions.vendorReview.createFail()))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService
	) {}
}
